



































import {Component, Prop, Vue} from 'vue-property-decorator'
import {CmsApiClient} from "@/_global/api_clients/CmsApiClient";

@Component
export default class ImageUploader extends Vue {
    @Prop() private previewUrl!: string;

    private isUploading: boolean = false;

    private async onChange(e: InputEvent) {
        this.isUploading = true;
        const formData = new FormData();
        const file = (e as any).target.files[0] || (e as any).dataTransfer.files[0];
        formData.append('file', file);
        const response: any = (await CmsApiClient.uploadFile(formData)).data;
        this.$emit("change", response.file_url);
        this.isUploading = false;
    }

    private onClickDelete() {
        this.$emit("delete");
    }
}

